import {ScrollTrigger} from "../LibrariesImport";

export default class AppearOnScroll {

	static init() {
		const items = document.querySelectorAll('[data-aos]');
		ScrollTrigger.create({
			trigger: items,
			start: 'top 90%',
			once: true,
			toggleClass: "appeared"
		});
	}
}
